"use strict";

if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Size", {
  value: {
    height: require("prop-types").number.isRequired,
    width: require("prop-types").number.isRequired
  },
  configurable: true
});


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/AutoSizer/types.js
// module id = 125
// module chunks = 0